// ============================== [群組名稱配置] ==============================

export const GROUP_NAME = {
  // 需求單相關
  DEMAND: 'demand/form',

  // 主站相關（整合現有分散的常量）
  HEADER: 'header',
  MAIN: 'main',
  FOOTER: 'footer',

  // 價目表
  PRICE_LIST: 'demand/price_list',
};

// ============================== [群組描述配置] ==============================

export const GROUP_DESCRIPTION = {
  DEMAND: '[需求單]',
  HEADER: '網站標頭資訊',
  MAIN: '網站主要內容',
  FOOTER: '網站頁尾資訊',
  PRICE_LIST: '[價目表]',
};

// ============================== [主要項目類型] ==============================

export const MAIN_ITEMS = {
  PARTNERS: 'partners_info',
  BANNER: 'banner',
  MOBILE: 'mobile_content',
  VIDEO: 'video_content',
};

// ============================== [需求單相關常量] ==============================

export const DEMAND_CONSTANTS = {
  DEFAULT_NAME: 'demand',
  DEFAULT_DESCRIPTION: '[需求單]',
};

// ============================== [聊天室訊息類型] ==============================

export const CHAT_MESSAGE_TYPES = {
  MESSAGE: 'MESSAGE',    // 普通訊息
  LIKE: 'LIKE',          // 線上捻香
  SHARE: 'SHARE',        // 線上悼念
  FOLLOW: 'FOLLOW',      // 線上獻花
  JOIN: 'JOIN',          // 加入房間
  LEAVE: 'LEAVE',        // 離開房間
};

// 快速動作映射
export const QUICK_ACTION_MAP = {
  blessing: { action: CHAT_MESSAGE_TYPES.LIKE, content: '線上捻香' },
  memorial: { action: CHAT_MESSAGE_TYPES.SHARE, content: '線上悼念' },
  flower: { action: CHAT_MESSAGE_TYPES.FOLLOW, content: '線上獻花' }
}; 